import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "section"
}
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = { class: "section-title medium" }
const _hoisted_4 = { class: "navigation" }
const _hoisted_5 = { class: "see-all" }
const _hoisted_6 = { class: "nav-buttons" }
const _hoisted_7 = {
  key: 0,
  class: "load-more-container"
}

import { ref } from "vue";
import LotteryCard from "@/components/LotteryCard.vue";
import NavButtons from "@/components/base/NavButtons.vue";
import type { UpcomingDraw } from '@/types/lottery';


const __default__ = {
  name: 'FavoritesSection'
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    favorites: {},
    isFavorited: { type: Function }
  },
  emits: ["favorite", "bet"],
  setup(__props: any, { emit: __emit }) {

const favoritesRef = ref<HTMLElement | null>(null);

const props = __props

const emit = __emit

const scrollFavoritesLeft = () => {
  if (favoritesRef.value) {
    const cardWidth = favoritesRef.value.offsetWidth;
    favoritesRef.value.scrollBy({ left: -cardWidth, behavior: "smooth" });
  }
};

const scrollFavoritesRight = () => {
  if (favoritesRef.value) {
    const cardWidth = favoritesRef.value.offsetWidth;
    favoritesRef.value.scrollBy({ left: cardWidth, behavior: "smooth" });
  }
};

const handleBet = (lottery: UpcomingDraw) => {
  // Handle betting on lottery
};

const handleFavorite = (game: UpcomingDraw) => {
  emit('favorite', game);
};

return (_ctx: any,_cache: any) => {
  return (_ctx.favorites && _ctx.favorites.length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('sections.favourites')), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.$t('common.seeAll')), 1),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(NavButtons, {
                onOnPrevious: scrollFavoritesLeft,
                onOnNext: scrollFavoritesRight
              })
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "cards-container",
          ref_key: "favoritesRef",
          ref: favoritesRef
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.favorites, (game) => {
            return (_openBlock(), _createBlock(LotteryCard, {
              key: game.id,
              lottery: game,
              layout: "horizontal",
              isFavorited: _ctx.isFavorited,
              onFavorite: () => _ctx.$emit('favorite', game),
              onBet: ($event: any) => (handleBet(game))
            }, null, 8, ["lottery", "isFavorited", "onFavorite", "onBet"]))
          }), 128))
        ], 512),
        (_ctx.hasMore)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "load-more-button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
              }, _toDisplayString(_ctx.$t('forms.loadMoreNumberGames')), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})